/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { Module, Node } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';
import { ICittaGiftCardBalanceCheckViewProps } from './citta-gift-card-balance-check';
export default (props: ICittaGiftCardBalanceCheckViewProps) => {
    const { GiftCardBalanceCheckModuleProps,
        GiftCardBalanceCheckCardNodeProps,
        GiftCardBalanceCheckCardNode,
        GiftCardBalanceCheckPinNodeProps,
        GiftCardBalanceCheckPinNode,
        GiftCardBalanceCheckResultNode,
        GiftCardBalanceCheckButtonNode } = props;
    return (
        <Module {...GiftCardBalanceCheckModuleProps}>
            <Node {...GiftCardBalanceCheckCardNodeProps}>
                {GiftCardBalanceCheckCardNode}
            </Node>
            <Node {...GiftCardBalanceCheckPinNodeProps}>
                {GiftCardBalanceCheckPinNode}
            </Node>
            {GiftCardBalanceCheckResultNode}
            {GiftCardBalanceCheckButtonNode}
        </Module >
    );
};
